import { AuthService } from './../user/auth.service';
import { RegistryService } from './../registry/registry.service';
import { RegistryFirebaseService } from './../registry/registry-firebase.service';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormArray, FormBuilder, Validators } from '@angular/forms';
import { CustomValidatorsService } from '../shared/validators.service';
import { Settings } from '../settings/settings';
import { Contribution } from '../track/contribution';
import { ActivatedRoute } from '@angular/router';
import { Gift } from '../gift/gift';
import { Registry } from '../registry/registry';
import { Http, RequestOptions , Headers} from '@angular/http';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-account-delete',
  templateUrl: './account-delete.component.html',
  styleUrls: ['./account-delete.component.scss']
})
export class AccountDeleteComponent implements OnInit {

  public settings: Settings;
  registry: Registry;

  private valueChanged = false;
  loaded = false;
reasons: string;
suggestions: string;
  processing = false;
  understand = false;
  constructor(
    private _http: Http,
    private _registryFirebaseService: RegistryFirebaseService,
    private _registryService: RegistryService,
    private _authService: AuthService,
    private route: ActivatedRoute
  ) {

    document.title = 'Account | Hitchd';
    this._authService.user.subscribe(user => {

      this._registryFirebaseService.initGiftsForUser(user);
    });

  }

  ngOnInit() {
    this._registryService.setScrollY(1);
    this.registry = this.route.snapshot.data.registry;


    this.settings = this.route.snapshot.data.settings;

 
    this.load();

    this._registryFirebaseService.killLoader();
  }



  load() {


  }
  handleLoaded(){

    this.loaded = true;
  }
  save() {

    this.processing = true;
    this._authService.user.subscribe(user => {

      if (user != null) {
        this._authService.authToken().subscribe(token => {

          let formValue = {
            token: token,
            reasons: this.reasons,
            suggestions: this.suggestions
          }
          const headers = new Headers({ 'Content-Type': 'application/json' }); // ... Set content type to JSON
          const options = new RequestOptions({ headers: headers });
         
          return this._http.post(environment.firebase.clouldFunctionHost + '/nukeAccount',  formValue, options)
          .subscribe(response => {


          this._authService.signOut();
          
            return response;
          });
    
        });
      }
  
      
    });



}
}



// WEBPACK FOOTER //
// ./src/app/account-delete/account-delete.component.ts